import React from 'react'
// hooks
import { useShowModal } from 'hooks/useShowModal'
// components
import { Button, BUTTON_LAYOUTS, CREATE_BUTTON_STYLE } from 'components/UI'
// constants
import { Modals } from 'constants/modals'

const CreatePlanTypeButton = () => {
  const { showModal } = useShowModal({ modalType: Modals.BUSINESS_ENTITY_MODAL })

  const onButtonClick = () => showModal()

  return (
    <Button
      onClick={onButtonClick}
      style={CREATE_BUTTON_STYLE}
      layout={BUTTON_LAYOUTS.PURPLE}
    >
      Create Position
    </Button>
  )
}

export default CreatePlanTypeButton
